
import React from "react";
import StatusBadge from "./StatusBadge";

interface MfaStatusSectionProps {
  verificationResult: any;
}

const MfaStatusSection: React.FC<MfaStatusSectionProps> = ({ verificationResult }) => {
  return (
    <section>
      <h3 className="text-lg font-medium mb-2">MFA Status</h3>
      
      <div className="space-y-3">
        <div className="flex items-center justify-between p-3 border rounded-md">
          <div>
            <div className="font-medium">MFA Record Exists</div>
            <div className="text-sm text-gray-500">User has a record in user_mfa table</div>
          </div>
          <StatusBadge condition={!!verificationResult?.details?.mfaStatus?.exists} />
        </div>
        
        <div className="flex items-center justify-between p-3 border rounded-md">
          <div>
            <div className="font-medium">Requires 2FA</div>
            <div className="text-sm text-gray-500">User is required to set up 2FA</div>
          </div>
          <StatusBadge condition={!!verificationResult?.details?.mfaStatus?.requires2FA} />
        </div>
        
        <div className="flex items-center justify-between p-3 border rounded-md">
          <div>
            <div className="font-medium">Completed 2FA Setup</div>
            <div className="text-sm text-gray-500">User has completed 2FA setup</div>
          </div>
          <StatusBadge condition={!!verificationResult?.details?.mfaStatus?.completed2FA} />
        </div>
      </div>
    </section>
  );
};

export default MfaStatusSection;
